/**
 * Guards for XOR-optional InstantDB links (warehouse vs event, task endpoints).
 * Orphan rows can occur when linked entities are deleted or sync is inconsistent.
 */

/** Drop itemLocation rows that have neither event nor storageLocation. */
export function filterValidItemLocations<
    T extends {
        event?: { id: string } | null;
        storageLocation?: { id: string } | null;
    },
>(locs: T[]): T[] {
    return locs.filter(loc => loc.event?.id != null || loc.storageLocation?.id != null);
}

/** Drop packing task rows with no recognizable source endpoint. */
export function filterValidPackingTaskEndpoints<
    T extends {
        fromEvent?: { id: string } | null;
        fromStorageLocation?: { id: string } | null;
    },
>(tasks: T[]): T[] {
    return tasks.filter(t => t.fromEvent?.id != null || t.fromStorageLocation?.id != null);
}

/** Drop inventory history rows that have neither event nor storageLocation. */
export function filterValidInventoryHistory<
    T extends {
        event?: { id: string } | null;
        storageLocation?: { id: string } | null;
    },
>(rows: T[]): T[] {
    return rows.filter(r => r.event?.id != null || r.storageLocation?.id != null);
}
